import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Header from "./Header";
import { Loader } from "src/common/components";

const useStyles = makeStyles((theme: any) => ({
  content: {
    maxWidth: "100%",
    position: "relative" as "relative"
  },
  root: {
    "@media print": {
      background: "none" as "none"
    },
    background: "#f6f6f6",
    maxWidth: "100%",
    minHeight: "100vh"
  },
  toolbar: {
    ...theme.mixins.toolbar,
    "@media print": {
      display: "none" as "none"
    },
    marginBottom: 30
  }
}));
interface IProps {
  children: React.ReactNode;
}

const Layout = (props: IProps) => {
  const { children } = props;
  const classes = useStyles();
  return (
    <React.Suspense fallback={<Loader />}>
      <Header />
      <div className={classes.root}>
        <div className={classes.toolbar} />
        {children}
      </div>
    </React.Suspense>
  );
};

// using React.memo here will prevent navigation
export default Layout;
